module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/download-icon-e30dfc5aec28105552baaeed064ac71d.svg&quot;;"